"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _react = _interopRequireDefault(require("react"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _reactRedux = require("react-redux");
var _portals = require("@mulesoft/exchange-ui-portals-store/lib/domains/portals");
var _ConfirmModal = _interopRequireDefault(require("@mulesoft/exchange-ui-components/lib/components/ConfirmModal"));
var _routes = require("../../../utils/routes");
var _modals = require("../../../utils/modals");
var DiscardDraftModal = function DiscardDraftModal() {
  var _useModals = (0, _exchangeReactHooks.useModals)(),
    closeModal = _useModals.closeModal;
  var dispatch = (0, _reactRedux.useDispatch)();
  var getPath = (0, _exchangeReactHooks.useGetPath)();
  var config = (0, _exchangeReactHooks.useConfig)();
  var push = (0, _exchangeReactHooks.usePush)();
  var asset = (0, _exchangeReactHooks.useAsset)();
  var isLoading = (0, _reactRedux.useSelector)(function (state) {
    return _portals.selectors.isDiscardingDraft(state, asset);
  });
  var onCancel = function onCancel() {
    return closeModal();
  };
  var onConfirm = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return dispatch(_portals.actions.discardDraft(asset));
          case 2:
            closeModal({
              discardedDraft: true
            });
            push(getPath('page', (0, _routes.getPageParams)(asset, config.defaultPageName)));
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onConfirm() {
      return _ref.apply(this, arguments);
    };
  }();
  var body = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", null, "Are you sure you want to delete the portal draft for this version?"), /*#__PURE__*/_react.default.createElement("p", null, "This action cannot be reversed."));
  return /*#__PURE__*/_react.default.createElement(_ConfirmModal.default, {
    testId: "delete-portal-draft-modal",
    title: "Discard portal draft",
    confirmButtonText: "Discard draft",
    body: body,
    isDanger: true,
    isLoading: isLoading,
    onCancel: onCancel,
    onConfirm: onConfirm
  });
};
var DiscardDraftModalContainer = (0, _modals.setModalName)('DiscardDraftModal')(DiscardDraftModal);
var _default = exports.default = DiscardDraftModalContainer;
//# sourceMappingURL=DiscardDraftModal.js.map